var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisclaimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79 147.688C116.935 147.688 147.688 116.935 147.688 79C147.688 41.0649 116.935 10.3125 79 10.3125C41.0649 10.3125 10.3125 41.0649 10.3125 79C10.3125 116.935 41.0649 147.688 79 147.688Z",
    fill: "#D3EDEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79 98.625C77.6988 98.625 76.4509 98.1081 75.5308 97.188C74.6107 96.2679 74.0938 95.02 74.0938 93.7188V44.6562C74.0938 43.355 74.6107 42.1071 75.5308 41.187C76.4509 40.2669 77.6988 39.75 79 39.75C80.3012 39.75 81.5491 40.2669 82.4692 41.187C83.3893 42.1071 83.9062 43.355 83.9062 44.6562V93.7188C83.9062 95.02 83.3893 96.2679 82.4692 97.188C81.5491 98.1081 80.3012 98.625 79 98.625Z",
    fill: "url(#paint0_linear_5930_21845)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79 118.25C81.7096 118.25 83.9062 116.053 83.9062 113.344C83.9062 110.634 81.7096 108.438 79 108.438C76.2904 108.438 74.0938 110.634 74.0938 113.344C74.0938 116.053 76.2904 118.25 79 118.25Z",
    fill: "url(#paint1_linear_5930_21845)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5930_21845",
    x1: 76.6842,
    y1: 9.42718,
    x2: 88.0529,
    y2: 10.0395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0004B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5930_21845",
    x1: 76.6842,
    y1: 103.384,
    x2: 87.0078,
    y2: 106.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0004B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimer);
export default __webpack_public_path__ + "static/media/disclaimer.c0e49d72fe6a26ea379d2c2aba8f52db.svg";
export { ForwardRef as ReactComponent };